import React from 'react';
import { Box, SxProps } from '@mui/material';

const boxStyles: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  height: 105,
  background: {
    xs: `url('${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/banner-left.png') top left/cover no-repeat, #1E293B`,
    sm: `url('${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/banner-left.png') top left/contain no-repeat, url('${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/banner-right.png') top right/contain no-repeat, #1E293B`,
  },
};

const DiscountBanner: React.FC = () => {
  return (
    <Box sx={boxStyles}>
      <Box>
        <img
          src={`${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/pearson.png`}
          alt="pearson"
          height={105}
          width="auto"
        />
      </Box>
    </Box>
  );
};

export default DiscountBanner;
